'use client';

import * as React from 'react';
import { AuthProvider } from '@/context/auth-context';
import { FirebaseClientProvider } from '@/firebase/client-provider';
import { LockProvider } from '@/context/lock-context';
import { Toaster } from '@/components/ui/toaster';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <FirebaseClientProvider>
      <AuthProvider>
        <LockProvider>
          {children}
          <Toaster />
        </LockProvider>
      </AuthProvider>
    </FirebaseClientProvider>
  );
}
